import { render, staticRenderFns } from "./TranscribeSegment.vue?vue&type=template&id=1a574f65&"
import script from "./TranscribeSegment.vue?vue&type=script&lang=js&"
export * from "./TranscribeSegment.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeSegment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports